import styled from 'styled-components';

import { getTheme } from 'lib/styles/getTheme';

export const Input = styled.input`
  font-family: ${getTheme('text.fontFamily')};
`;
